import { useTranslation } from 'react-i18next';
import {
  IEmployee,
  IFamilyMember,
} from '@/common/integrations/menhir/employee/employee/employee.types';
import { getMemberIconByAge } from '@/common/utils/family-members';
import { CardAction, IconCheck, IconUser } from '@coverflex-tech/hypernova';
import { css } from './MemberCard.css';

interface ISharedProps {
  sublabel?: string;
  className?: string;
}

interface IEmployeeProps extends ISharedProps {
  type: 'employee';
  member: IEmployee;
}

interface IFamilyProps extends ISharedProps {
  type: IFamilyMember['type'];
  member: IFamilyMember;
}

interface IVisualProps extends ISharedProps {
  onClick?: never;
  selected?: never;
}

interface ISelectableProps extends ISharedProps {
  onClick: () => void;
  selected?: boolean;
}

type IProps = (IEmployeeProps | IFamilyProps) &
  (IVisualProps | ISelectableProps);

export const MemberCard = ({ member, type, selected, onClick }: IProps) => {
  const { t } = useTranslation();
  const icon =
    type === 'employee' ? <IconUser /> : getMemberIconByAge(member.birthdate);
  return (
    <div data-test-id="member-card">
      <CardAction
        plain={selected}
        title={member.shortName}
        description={
          type !== 'employee' &&
          t(`dashboard.family_member_details.family_member_type.${type}`)
        }
        icon={icon}
        iconBadgeColor={selected ? 'accentPrimary40' : 'accentSecondary20'}
        onClick={!selected ? onClick : undefined}
        action={
          selected && (
            <IconCheck className={css.icon} themeColor="accentPrimary10" />
          )
        }
      />
    </div>
  );
};
